import React, { useState } from "react";
import {
  Box,
  Collapse,
  IconButton,
  makeStyles,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Typography
} from "@material-ui/core";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";
import { MedicamentoItem } from "../gestionEmpadronamiento/MedicamentoItem";
import { DiagnosticoItem } from "../gestionEmpadronamiento/DiagnosticoItem";
//import { setActiveStep, setAfiliadoSeleccionado, setDiagnosticos, setMedicamentos, setShowForm, setSolicitud } from "../../../actions/empadronamiento/Empadronamiento";
//import { useDispatch } from "react-redux";
//import { STEPPER_MEDICACION } from "../../../utils/constants";

const useStyles = makeStyles({
  iconEstado: {
    "&:hover": {
      backgroundColor: "#80808026",
    },
  },
});

const optionsfecha = {
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
};

export const MedicacionHistorialItem = (props) => {
  //const dispatch = useDispatch();
  const classes = useStyles();

  const [open, setOpen] = React.useState(false);
  const [openDiag, setOpenDiag] = useState(false);
  //const [repetirVisible, setRepetirVisible] = useState(true);

  const { solicitud } = props;

  return (
    <React.Fragment>
      <TableRow className={classes.iconEstado}>
        <TableCell>{solicitud?.estadoSolicitud?.descripcion}</TableCell>
        <TableCell>{solicitud?.idSolicitudEmp}</TableCell>
        <TableCell>{solicitud?.idSolicitud}</TableCell>
        <TableCell>
          {new Date(solicitud?.fechaInicio).toLocaleString("es", optionsfecha)}
        </TableCell>
        <TableCell align="left">{solicitud?.tipoEmpadronamiento?.descripcion}</TableCell>
        <TableCell align="left">{solicitud?.usuario?.userName}</TableCell>
        <TableCell>
          {solicitud.empadronamientoSolicitud?.diagnosticos.length > 0 && (
            <IconButton
              aria-label="expand row"
              size="small"
              onClick={() => setOpenDiag(!openDiag)}
            >
              {openDiag ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            </IconButton>
          )}
        </TableCell>
        <TableCell>
          {solicitud.medicamentos.length > 0 && (
            <IconButton
              aria-label="expand row"
              size="small"
              onClick={() => setOpen(!open)}
            >
              {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            </IconButton>
          )}
        </TableCell>
        {/*<TableCell>
          {repetirVisible && solicitud?.idEstadoSolicitud === EMPADRONAMIENTO_MEDICACION_ESTADOS.AUTORIZADA && 
          <Button
            style={{
              margin: "0.5rem",
              flexBasis: "30%",
              backgroundColor: "purple",
              color: "white",
            }}
            variant="contained"
            onClick={() =>
              onClickRepetir()
            }
          >
            Repetir
          </Button>}
        </TableCell>*/}
      </TableRow>
      <TableRow>
        <TableCell
          style={{ paddingBottom: 0, paddingTop: 0, paddingLeft: 20 }}
          colSpan={3}
        >
          <Collapse in={openDiag} timeout="auto" unmountOnExit>
            <Box margin={1}>
              <Typography variant="h6" gutterBottom component="div">
                Diagnósticos
              </Typography>
              <Table size="small" aria-label="purchases">
                <TableHead>
                  <TableRow>
                    <TableCell>Descripción</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {solicitud.empadronamientoSolicitud?.diagnosticos.map((diagnostico) => (
                    <DiagnosticoItem
                      key={diagnostico?.idDiagnostico?.toString()}
                      item={diagnostico}
                    />
                  ))}
                </TableBody>
              </Table>
            </Box>
          </Collapse>
        </TableCell>
        <TableCell
          style={{ paddingBottom: 0, paddingTop: 0, paddingLeft: 20 }}
          colSpan={9}
        >
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box margin={1}>
              <Typography variant="h6" gutterBottom component="div">
                Medicamentos
              </Typography>
              <Table size="small" aria-label="purchases">
                <TableHead>
                  <TableRow>
                    <TableCell>Presentación</TableCell>
                    <TableCell>Laboratorio</TableCell>
                    <TableCell>Nombre</TableCell>
                    <TableCell>Drogas</TableCell>
                    <TableCell align="right">Cantidad</TableCell>
                    <TableCell>Dosis</TableCell>
                    <TableCell>Posología</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {solicitud.medicamentos.filter((medicamento) => medicamento.fechaBaja == null).map((medicamento) => (
                    <MedicamentoItem
                      key={medicamento?.idMedicamento?.toString()}
                      item={medicamento}
                    />
                  ))}
                </TableBody>
              </Table>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
};
